import Image from "next/image";
// import '../styles/community.css';
import { useSelector } from "react-redux";


export default function CommunityCard({ image_path, heading, title, amount, id, description, onOpen }) {
 
    const loginUserId = useSelector((state) => state.auth.userId);
    return (
        <div className="community-pricing-card mx-auto">
            <Image src={image_path} alt={heading} width={80} height={80} />
            <div className="community-badge-supporter mb-3">{heading}</div>
            <div className="mb-3 community-title">{title}</div>

            <div className="community-price">
                {amount ? (
                    <>
                        ${amount}<span className="fw-normal">/mo</span>
                    </>
                ) : (
                    "Custom"
                )}
            </div>

            {/* Button */}
            
            <button
                className="cta-btn ms-1 py-1 px-4 popupButn"
                onClick={() => onOpen({ image_path, heading, title, amount,id, description ,onOpen,iScommunity: true,type: "community",})}
            >
                {description}
            </button>
        </div>
    );
}
